var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationClone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3164,
    cy: 10,
    r: 9.75,
    fill: "#EBFAFA",
    stroke: "#0FADAD",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1446 6.25756C9.99994 6.32528 9.77714 6.32293 9.63419 6.25144C9.14978 6.01015 8.60493 5.8728 8.02719 5.8728C6.02401 5.87277 4.3999 7.49679 4.3999 9.49982C4.3999 11.5031 6.02375 13.1271 8.02719 13.1271C8.60496 13.1271 9.14981 12.9895 9.63419 12.7481C9.7771 12.677 9.9999 12.6742 10.1446 12.7423C10.6035 12.9577 11.1145 13.0791 11.6541 13.0791C13.6278 13.0791 15.2332 11.4735 15.2332 9.49978C15.2332 7.52631 13.6278 5.92067 11.6541 5.92067C11.1145 5.92071 10.6035 6.04227 10.1446 6.25756ZM10.6254 12.3873C10.475 12.3331 10.4582 12.1942 10.572 12.0821C11.2395 11.4244 11.6537 10.5108 11.6537 9.49982C11.6537 8.48887 11.2395 7.57554 10.572 6.91781C10.4582 6.80555 10.475 6.66663 10.6254 6.61261C10.9472 6.49654 11.2927 6.43201 11.6537 6.43201C13.3453 6.43201 14.7218 7.80807 14.7218 9.49964C14.7218 11.1913 13.3453 12.5675 11.6537 12.5675C11.2927 12.5675 10.9472 12.5031 10.6254 12.3873Z",
    fill: "#0FADAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationClone);
export default __webpack_public_path__ + "static/media/notification_clone.37f4af67d6803951b82d4493c9b80cbf.svg";
export { ForwardRef as ReactComponent };